<script>
export default {
  name: 'MultipleAttentionModal',
  components: {},
  props: {},
  data() {
    return {
      sheet: false
    }
  },
  computed: {},
  created() {},
  methods: {
    openModal() {
      this.sheet = true;
    },
    closeModal(){
      this.sheet = false;
    }
  }
}
</script>

<template>
  <div
    :class="$style.container"
    data-app>
    <div
      :class="$style.sheet"
      @click="sheet = !sheet">
      <slot
        name="title"/>
      <div :class="$style.sheet__eta" >
        <slot name="eta"/>
        <div
          :class="$style.sheet__action"
        >
          <img
            :class="$style.sheet__action__icon"
            src="@assets/images/accordion/chevron_right.svg"
            alt=">"
          >
        </div>
        <div :class="$style.vbottom">
          <v-bottom-sheet
            v-model="sheet"
            :hide-overlay="false"
            height="400px">
            <v-sheet
              :class="$style.sheet__container"
              class="rounded">
              <div
                :class="$style.sheet__close"
                @click="sheet = !sheet"/>
              <div :class="$style.sheet__body">
                <slot name="sheetHeader"/>
                <slot name="sheetBody"/>
                <slot name="sheetFooter"/>
              </div>
            </v-sheet>
          </v-bottom-sheet>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" module>
@import '@design';

.vbottom /deep/ [class*="v-dialog__content--active"] {
  background-color: rgba(0,0,0, 0.5);
}

.vbottom /deep/ [class*="v-dialog--active"] {
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
  background: white !important;
}

.container {
  padding: 1rem;
}

.sheet {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  padding: .5rem;

  &__close {
    position: absolute;
    height: 10px;
    width: 50px;
    top: -15px;
    right: 0;
    left: -25px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
    background: white;
  }

  &__eta {
    display: flex;
    align-items: center;
  }

  &__action {
    display: flex;
    align-items: center;
    margin-left: 1rem;
    margin-right: -1rem;

    &__icon {
      transition: transform 0.5s ease;
      max-width: 2rem;
    }
  }

  &__container {
    border-top-left-radius: 22px;
    border-top-right-radius: 22px;
    position: relative;
  }

  &__body {
    padding: 1rem;
    text-align: left;
    background: white !important;

  }

}

</style>
